module.exports = __webpack_public_path__ + "img/ts.1f3db5ff.png";